import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EntryResponse } from 'src/app/shared/models/generic.models';
import { LeaderboardList, LeaderboardResult } from 'src/app/shared/models/leaderboard.model';

@Injectable({
  providedIn: 'root'
})
export class LeaderboardApiService {

  constructor(private http:HttpClient) { }

  get():Observable<LeaderboardList>{
    return this.http.get<EntryResponse<LeaderboardList>>('/api/Leaderboards')
      .pipe(map((x:EntryResponse<LeaderboardList>) => x.Entry ));
  }

  getComissionGroupLeaderboard(commisionGroupId: number):Observable<LeaderboardList>{
    return this.http.get<EntryResponse<LeaderboardList>>(`/api/Leaderboards/CommisionGroup/${commisionGroupId}`)
      .pipe(map((x:EntryResponse<LeaderboardList>) => x.Entry));
  }
}
